/**
 * Build metadata injected at compile time via Vite's define config.
 * These constants are replaced during the build process.
 */

// These will be replaced by Vite during build
declare const __APP_VERSION__: string;
declare const __GIT_COMMIT_HASH__: string;
declare const __BUILD_TIMESTAMP__: string;

export interface BuildInfo {
  version: string;
  commitHash: string;
  commitShort: string;
  buildTimestamp: string;
  buildDate: string;
}

/**
 * Returns build metadata for display in the application footer.
 */
export function getBuildInfo(): BuildInfo {
  const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
  const commitHash = typeof __GIT_COMMIT_HASH__ !== 'undefined' ? __GIT_COMMIT_HASH__ : 'unknown';
  const buildTimestamp =
    typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : new Date().toISOString();

  const commitShort = commitHash.substring(0, 7);
  const buildDate = new Date(buildTimestamp).toISOString().split('T')[0];

  return {
    version,
    commitHash,
    commitShort,
    buildTimestamp,
    buildDate
  };
}

/**
 * Formats build info as a single-line string for display.
 * Example: "v0.1.0 • 9b9c13d • Built 2025-10-09"
 */
export function formatBuildInfo(): string {
  const info = getBuildInfo();
  return `v${info.version} • ${info.commitShort} • Built ${info.buildDate}`;
}
